import Vue from 'vue';
import axios from 'axios';
import { getEventBus } from '../eventBus';

export function translate(key, replacements = {}) {
  const translations = Vue.prototype.$translations;

  if (translations && translations[key]) {
    let translatedText = translations[key];

    for (const placeholder in replacements) {
      if (replacements.hasOwnProperty(placeholder)) {
        const value = replacements[placeholder];
        const regex = new RegExp(`:${placeholder}`, 'g');
        translatedText = translatedText.replace(regex, value);
      }
    }

    return translatedText;
  }
  return key;
}

Vue.filter('translate', translate);

const eventBus = getEventBus('translations');

export default {
  install(Vue, options) {
    Vue.prototype.$translationsLoaded = false;
    axios
      .get('/api/getTranslations')
      .then((response) => {
        Vue.prototype.$translations = response.data;
        Vue.prototype.$translationsLoaded = true;
        eventBus.$emit('translations-loaded');
      })
      .catch((error) => {
        console.error('Error fetching translations:', error);
      });
  },
};
